<template>
  <form @submit.prevent="onFormSubmit" class="space-y-4 text-left">
    <MosaicUiInputCleanText
      type="text"
      name="company"
      v-model="formData.company"
      :placeholder="t('meclee-ui.businessConnect.form.company.label')"
      :error-messages="validationErrors[`company`]"
      :disabled="isLoading"
    />

    <MosaicUiInputCleanText
      type="number"
      name="countOfStaff"
      v-model="formData.countOfStaff"
      :label="t('meclee-ui.businessConnect.form.count.label')"
      :error-messages="validationErrors[`countOfStaff`]"
      :disabled="isLoading"
    />

    <MosaicUiDropdownsDefaultDropdown
      :label="t('meclee-ui.businessConnect.form.format.label')"
      class="items-start"
      v-model="formData.format"
      :options="formatOptions"
      :disabled="isLoading"
    >
      <template #no-select-placeholder>
        {{ t(`meclee-ui.businessConnect.form.format.noSelected`) }}
      </template>
    </MosaicUiDropdownsDefaultDropdown>

    <MosaicUiInputCleanText
      type="text"
      name="name"
      v-model="formData.name"
      :placeholder="t('meclee-ui.businessConnect.form.name.label')"
      :error-messages="validationErrors[`name`]"
      :disabled="isLoading"
    />

    <MosaicUiInputCleanText
      type="tel"
      name="phone"
      v-model="formData.phone"
      :placeholder="t('meclee-ui.businessConnect.form.phone.label')"
      :error-messages="validationErrors[`phone`]"
      :disabled="isLoading"
    />

    <MosaicUiInputCleanText
      type="email"
      name="email"
      v-model="formData.email"
      :placeholder="t('meclee-ui.businessConnect.form.email.label')"
      :error-messages="validationErrors[`phone`]"
      :disabled="isLoading"
    />

    <div class="flex justify-center">
      <MecleeUiButton :disabled="isLoading" class="mini" type="submit">
        {{ t('meclee-ui.businessConnect.buttons.save') }}
      </MecleeUiButton>
    </div>
  </form>
</template>

<script lang="ts" setup>
import {useB2BLeadForm} from "../composables/useB2BLeadForm";

const gtm = useGtm();
const {t} = useI18n();
const {isLoading, formData, validationErrors, sendForm} = useB2BLeadForm();
const emit = defineEmits(['submitted']);

const formatOptions = [
  { value: t('meclee-ui.businessConnect.form.format.options.video'), label: t('meclee-ui.businessConnect.form.format.options.video') },
  { value: t('meclee-ui.businessConnect.form.format.options.support'), label: t('meclee-ui.businessConnect.form.format.options.support') },
  { value: t('meclee-ui.businessConnect.form.format.options.trainings'), label: t('meclee-ui.businessConnect.form.format.options.trainings') },
];

async function onFormSubmit() {
  try {
    await sendForm();
    gtm.trackEvent({
      event: 'form_business'
    });
    emit('submitted');
  } catch (e) {

  }
}
</script>

<style scoped>

</style>
